import { Outlet, useLocation, useParams } from "react-router-dom";
import { VendorDirectoryPartnerScopeProvider } from "../../../hooks/useVendorDirectoryPaths";
import { casamapaAdminPortalPath } from "../../../constants/casamapaAdminPortalPaths";
import { casamapaAdminVendorHubPath } from "../../../constants/casamapaAdminVendorPaths";
import { useLocale } from "../../../intl";
import PartnerVendorWorkspaceChrome from "../../partner/PartnerVendorWorkspaceChrome";
import "../../../styles/partnerVendorWorkspace.css";
import "../../../styles/casamapaVendorDirectoryAdmin.css";

function workspaceRelativePath(pathname, workspaceRoot) {
  const prefix = `${workspaceRoot}/`;
  if (!pathname.startsWith(prefix)) {
    return "";
  }
  return pathname.slice(prefix.length).replace(/^\/+|\/+$/g, "");
}

export default function CasaMapaAdminVendorWorkspaceLayout() {
  const { clientViewId } = useParams();
  const location = useLocation();
  const { t } = useLocale();

  if (!clientViewId) {
    return null;
  }

  const serviciosBase = casamapaAdminVendorHubPath(clientViewId, "");
  const workspaceRoot = casamapaAdminVendorHubPath(clientViewId);
  const relativePath = workspaceRelativePath(location.pathname, workspaceRoot);

  return (
    <VendorDirectoryPartnerScopeProvider
      clientViewId={clientViewId}
      serviciosBase={serviciosBase}
      isPartnerPortal={false}
    >
      <div className="partner-vendor-workspace partner-vendor-workspace--admin">
        <PartnerVendorWorkspaceChrome
          clientViewId={clientViewId}
          relativePath={relativePath}
          hubPathBuilder={casamapaAdminVendorHubPath}
          dashboardPath={casamapaAdminPortalPath("vendors")}
          dashboardLabel={t("realEstate.casaMapa.admin.vendorDirectoryWorkspace.vendors.title")}
          exitPath={casamapaAdminPortalPath("vendors")}
          exitLabel={t("realEstate.casaMapa.admin.vendorDirectoryWorkspace.exitDashboard")}
          subnavVariant="compact"
          admin
        />

        <div className="partner-vendor-workspace__content">
          <Outlet
            context={{
              activeView: { name: "CasaMapa" },
              partnerVendorDirectory: true,
              casamapaAdminVendorWorkspace: true,
            }}
          />
        </div>
      </div>
    </VendorDirectoryPartnerScopeProvider>
  );
}
